/* jshint esversion: 6 */
import React from 'react';
import { SUB_PREVIEW_UPDATE } from 'app/redux/constants.js';
import TermChangeDialog from '@/shadcn/components/account/PlanChange/TermChangeDialog.tsx';
import { annualSavings } from '@/shadcn/components/account/PlanChange/plans.ts';
import useChangePreview, { useConfirmationStep } from './useChangePreview.js';

/*
 * Opens through the legacy modal stack to confirm switching between monthly and annual
 * billing. PricingModule.changeTerm passes the new `term` and what confirming does;
 * everything else comes from App's live props. The page closes the modal once
 * SUB_UPDATE settles.
 */
export default function TermChangeConfirm(props) {
    const { app, plans, user } = props,
        constants = app.config.constants,
        level = parseInt(user.detail.pubLevel, 10),
        term = parseInt(props.term, 10),
        current = plans.current,
        prices = annualSavings(plans.details[level] || {}, constants.SUBSCRIPTION_TERM_MONTHLY, constants.SUBSCRIPTION_TERM_ANNUAL, {
            add_on_social: parseInt(current.addOns?.add_on_social?.qty || 0, 10),
            add_on_posts_1: parseInt(current.addOns?.add_on_posts_1?.qty || 0, 10)
        }),
        post = { level, term },
        preview = useChangePreview(props, SUB_PREVIEW_UPDATE, post);

    useConfirmationStep();

    const close = () => {
        props.closeAllModals();
    };

    return (
        <TermChangeDialog
            toAnnual={term === constants.SUBSCRIPTION_TERM_ANNUAL}
            monthly={prices.monthly}
            annual={prices.annual}
            savings={prices.savings}
            savingsPct={prices.pct}
            nextBilling={current.nextBilling}
            preview={preview}
            busy={app.loading.SUB_UPDATE}
            onConfirm={() => props.onConfirm({ level, term })}
            onCancel={close}
            onClose={close} />
    );
}
